module.exports = __webpack_public_path__ + "static/logo-279f7759f011329aa8257ce79415be21.png";